export default __webpack_public_path__ + "static/media/049-parking.4c036ccb.png";